import { FETCH_CLIENT_SERVICE_VERSIONS, SET_DEFAULT_SERVICE_VERSION } from './mutation-types'

export default {
  [FETCH_CLIENT_SERVICE_VERSIONS] (state, serviceVersions) {
    state.serviceVersions = { ...state.serviceVersions, ...serviceVersions }
  },
  [SET_DEFAULT_SERVICE_VERSION] (state, defaultServiceVersion) {
    state.defaultServiceVersion = { ...state.defaultServiceVersion, ...defaultServiceVersion }
  }
}
